import React from "react";

import type { LovfortolkningProps } from "../../../../lib/modules/listSearchUtils/index.d";
import Base from "../Base/Base";

export default function Lovfortolkning(props: Readonly<LovfortolkningProps>) {
  const {
    contentTypeDisplayname,
    relevantLaws,
    firstPublish,
    localizedForListSearch
  } = props;

  return (
    <Base showPdfIcon {...props}>
      { contentTypeDisplayname && <p className="text-neutral-subtle">{contentTypeDisplayname}</p> }
      { (relevantLaws && relevantLaws?.length > 0) && <p className="text-neutral-subtle">{relevantLaws.join(" | ")}</p> }
      { firstPublish
        && (
          <time dateTime={firstPublish}>
            <div className="flex nt-flex-col tablet:nt-flex-row">
              <span className="mr-xxs">{localizedForListSearch?.date ?? "Dato:"}</span>
              <span>{firstPublish}</span>
            </div>
          </time>
        )}
    </Base>
  );
}
